import React from 'react';
import { getBrand } from '../../../utils';
import { Icon } from '../../icon';

export type StandaloneCheckboxProps = {
  readonly value: boolean;
};

const getIconType = () => {
  const brand = getBrand();

  if (brand === 'fuzehealth' || brand === 'fuzerx') {
    return 'secondary';
  }

  return undefined;
};

export const StandaloneCheckbox = ({ value }: StandaloneCheckboxProps) => {
  const iconType = getIconType();
  return (
    <Icon
      name={value ? 'checkbox-duo' : 'checkbox'}
      type={iconType}
      testID="standaloneCheckbox"
    />
  );
};
